import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function OttSubscriptionApi() {
  const faqs = [
    {
      question: "What is Mokshiq OTT Subscription API?",
      answer: "Mokshiq OTT Subscription API (by Rakle Service Private Limited) allows fintech apps and retailers to issue voucher codes and activation links for Disney+ Hotstar, SonyLIV, Zee5, Amazon Prime, and Netflix."
    },
    {
      question: "How are OTT subscription codes delivered?",
      answer: "Voucher codes and direct activation links are delivered instantly in the API JSON response and sent to the customer via SMS/WhatsApp."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-tv me-2"></i>Digital Entertainment API
            </span>
            <h1 className="page_title text-white mb-3">OTT Subscription &amp; Voucher API</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Instant OTT premium subscription voucher generation powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Recharge APIs</a></li>
              <li className="active"><a href="#!">OTT Subscription API</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-film text-danger fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Disney+, SonyLIV, Zee5</h3>
                  <p className="text-muted small">Direct API connection for monthly, quarterly, and annual subscription voucher codes.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-bolt text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Instant SMS Vouchers</h3>
                  <p className="text-muted small">Automated SMS and WhatsApp voucher code delivery directly to customer mobile number.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-percent text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">High Reselling Margins</h3>
                  <p className="text-muted small">Earn up to 15% flat margin on digital entertainment gift vouchers and subscriptions.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="OTT Subscription FAQs" subtitle="Frequently asked questions about digital OTT voucher API integration." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default OttSubscriptionApi;
